import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ServerErrorService } from '../server-error/server-error.service';
import { tap } from 'rxjs/operators';
import { routes } from 'src/routes';

@Injectable()
export class ServerErrorGuard {
  private readonly serverErrorService = inject(ServerErrorService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.serverErrorService.serverError$.pipe(
      tap((value) => {
        if (!value) {
          this.router.navigateByUrl(`${routes.userList}`);
        }
      })
    );
  }
}
